(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-mobile-carousel"] && !Shopify.designMode) return;
  try {
    
  class FcMobileCarousel extends HTMLElement {
    connectedCallback() {
      if (typeof Swiper === 'undefined') return;

      this._initMobile();
      this._initDesktop();
    }

    _initMobile() {
      const swiperEl = this.querySelector('.fc-mc__swiper');
      const prevEl = this.querySelector('.fc-mc__nav-btn--prev');
      const nextEl = this.querySelector('.fc-mc__nav-btn--next');

      if (!swiperEl) return;

      this._mobileSwiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
      });

      this._updateNavPosition = () => {
        const thumb = this.querySelector('.card--client-height');
        if (thumb) {
          this.style.setProperty('--fc-mc-nav-top', thumb.clientHeight / 2 + 'px');
        }
      };
      this._updateNavPosition();
      window.addEventListener('resize', this._updateNavPosition);
    }

    _initDesktop() {
      if (this.dataset.sliderEnable !== 'true') return;

      const section = this.closest('[data-section-id]');
      if (!section) return;

      const desktopEl = section.querySelector('.productSlider');
      if (!desktopEl) return;

      const slidesXl = parseFloat(this.dataset.showXl) || 4;
      const autoplayTime = parseInt(this.dataset.autoplayTime) || 3000;
      const shouldAutoplay = this.dataset.autoplay === 'true';

      const prevEl = section.querySelector('.swiper-button-prev');
      const nextEl = section.querySelector('.swiper-button-next');
      const paginationEl = section.querySelector('.swiper-pagination');

      this._desktopSwiper = new Swiper(desktopEl, {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        autoplay: shouldAutoplay ? { delay: autoplayTime } : false,
        pagination: paginationEl ? { el: paginationEl, clickable: true, type: 'fraction' } : false,
        navigation: {
          nextEl: nextEl || null,
          prevEl: prevEl || null,
        },
        breakpoints: {
          640: { slidesPerView: 2 },
          750: { slidesPerView: slidesXl },
          992: { slidesPerView: slidesXl },
        },
      });

      if (shouldAutoplay) {
        desktopEl.addEventListener('mouseenter', () => this._desktopSwiper.autoplay.stop());
        desktopEl.addEventListener('mouseleave', () => this._desktopSwiper.autoplay.start());
      }

      const slideThumbHeight = () => {
        const thumb = desktopEl.querySelector('.card--client-height');
        if (thumb) {
          section.style.setProperty('--slider-navigation-top-offset', thumb.clientHeight / 2 + 'px');
        }
      };
      slideThumbHeight();
      window.addEventListener('resize', slideThumbHeight);
    }

    disconnectedCallback() {
      if (this._mobileSwiper) this._mobileSwiper.destroy(true, true);
      if (this._desktopSwiper) this._desktopSwiper.destroy(true, true);
      if (this._updateNavPosition) window.removeEventListener('resize', this._updateNavPosition);
    }
  }

  if (!customElements.get('fc-mobile-carousel')) {
    customElements.define('fc-mobile-carousel', FcMobileCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));

      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));

      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

      this.onHideDropdown = this.closeSelector.bind(this);
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      document.body.removeEventListener('click', this.onHideDropdown);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      document.body.addEventListener('click', this.onHideDropdown);
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (shouldClose) {
        this.hidePanel();
      }
      let eventTarget = event.target;
      if (!eventTarget.closest('.dropdown__open_label')) {
        this.hidePanel();
      }

    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
